import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageNotFoundComponent } from './features/page-not-found/page-not-found.component';
import { RoleGuard } from './shared/guards/role.guard';

const routes: Routes = [
  {
    path: 'admin',
    loadChildren: () =>
      import('./features/admin/admin.module').then((m) => m.AdminModule),
    canActivate: [RoleGuard],
  },
  {
    path: 'public',
    loadChildren: () =>
      import('./features/public/survey/survey.module').then(
        (m) => m.SurveyModule
      ),
  },
  {
    path: 'request-access',
    loadChildren: () =>
      import('./features/request-access/request-access.module').then(
        (m) => m.RequestAccessModule
      ),
  },
  {
    path: '404',
    component: PageNotFoundComponent,
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
